import { Component, OnInit, OnDestroy , Input, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpModelFilterBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filter-base-component';
import { map, switchMap, takeUntil, startWith, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormControl } from '@angular/forms';



export class WizardElementsFilterTextMenuComponent extends WizardHpModelFilterBaseComponent implements OnInit  {

  searchValueUpdate = new Subject<string>();
  destroy$ = false;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  getOptionText(option) {
    return option.name;
  }

  onFilterByLibDataReceived(result) {
    this.options = result.items;
    this.filteredOptions = result.items;
  }

  getValue(event: Event): string {
    return (event.target as HTMLInputElement).value;
  }

  search(value: string) {
    this.setFilter(null, value, this.onFilterByLibDataReceived, null);
  }

}
